import { mediaData } from '@/mocks/home';

export default function MediaSection() {
  return (
    <section id="media" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-3 py-1 rounded-full bg-accent-500/15 text-accent-400 text-xs font-medium mb-3 whitespace-nowrap">
            视频专区
          </span>
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-50 font-heading">
            视频爆料
          </h2>
          <p className="text-foreground-500 text-sm mt-2 max-w-xl mx-auto">
            深度调查视频报道，用画面还原事件真相
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          {mediaData.map((item) => (
            <div
              key={item.id}
              className="rounded-lg overflow-hidden bg-background-200/70 border border-background-300/50 group cursor-pointer transition-all duration-300 hover:border-primary-500/30"
            >
              <div className="relative overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-44 md:h-48 object-cover transition-transform duration-500 group-hover:scale-105"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-background-900/30 group-hover:bg-background-900/20 transition-colors flex items-center justify-center">
                  <div className="w-12 h-12 md:w-14 md:h-14 rounded-full bg-primary-500/90 flex items-center justify-center group-hover:scale-110 transition-transform">
                    <i className="ri-play-fill text-foreground-50 text-xl md:text-2xl ml-0.5"></i>
                  </div>
                </div>
                <div className="absolute bottom-2 right-2 px-2 py-0.5 rounded bg-background-900/80 text-foreground-200 text-xs font-medium whitespace-nowrap">
                  {item.duration}
                </div>
              </div>
              <div className="p-4">
                <h3 className="text-foreground-100 font-medium text-sm group-hover:text-primary-400 transition-colors font-heading line-clamp-2">
                  {item.title}
                </h3>
                <div className="flex items-center gap-1 mt-2 text-xs text-foreground-600">
                  <i className="ri-eye-line"></i>
                  <span>{item.views} 次观看</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}